window.addEventListener("DOMContentLoaded", () => {
  const urlParams = new URLSearchParams(window.location.search);
  if (!urlParams.has("swoof") || !urlParams.has("product_cat")) return;
  const category = urlParams.get("product_cat");
  if (category.includes(",")) return;
  const currentCategoryElements = document.querySelectorAll(
    `[data-category='${category}']`
  );
  const defaultTitleElement = document.querySelector(".default-title");
  // Go through all elements with data-category attribute and display them.
  if (currentCategoryElements.length) {
    currentCategoryElements.forEach((element) => {
      element.classList.remove("d-none");
    });
  } else return;
  // If we found a default title element hide it.
  if (defaultTitleElement) {
    defaultTitleElement.classList.add("d-none");
  }
});
